module.exports = __webpack_public_path__ + "words_icon.png?9a3544d19c8f2dd6dd3250b77066e70a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/words_icon.png
// module id = 218
// module chunks = 0